export enum ComplianceApplicationProblemReason {
  UsCitizenship = 'usCitizenship',
  ForeignTaxResidency = 'foreignTaxResidency ',
  TaxResidencyCountry = 'taxResidencyCountry',
}
